import React from "react";
import globalHook from "use-global-hook";

import * as actions from "../actions";

const initialState = {
    user: {},
    site: null,
    equipment: null,
    space: null,
    building: null,
    currentModule: null,
    context: null,
    feature: null,
};

const useGlobal = globalHook(initialState, actions);

export default useGlobal;